export default [
  {
    path: '/daily-kpi',
    component: () => import('src/layouts/DefaultLayout'),
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'DailyKpi',
        component: () => import('./containers/DailyKpiContainer'),
      },
    ],
  },
]
